import { useEffect } from 'react';
import type { TradePosition } from '@sportspredict/shared';
import { parseTradeIntentPosition } from '@/utils';
import { useTradeIntent } from '../auth/use-trade-intent.hook';

export function useRestoreMarketTradeIntent({
	marketId,
	isRegisteredUser,
	canRestore,
	onRestore,
}: {
	marketId: string;
	isRegisteredUser: boolean;
	canRestore: boolean;
	onRestore: (position: TradePosition) => void;
}) {
	const { marketId: intentMarketId, position, clearTradeIntent } = useTradeIntent();
	const isIntentMarket = Boolean(intentMarketId) && intentMarketId === String(marketId);

	useEffect(() => {
		if (!isRegisteredUser || !isIntentMarket) return;

		const intentPosition = parseTradeIntentPosition(position);
		if (canRestore && intentPosition) onRestore(intentPosition);
		clearTradeIntent();
	}, [isRegisteredUser, isIntentMarket, canRestore, position, onRestore, clearTradeIntent]);
}
